import React from 'react'

import { GitlabServicesMtsRuMtsMediaCorporateCorporateBackendProjectsProject as Projects } from 'api/models'
import classNames from 'classnames'
import { CatalogItemLabel, Image } from 'shared/components'
import { transformGenre } from 'shared/pipes'

import classes from './CatalogItem.module.scss'

type Props = {
  item: Projects
  isActive: boolean
}
export const CatalogItem = ({ item, isActive }: Props): JSX.Element => {
  const renderGenre = () => {
    const _genre: number[] = item.genre || []
    const genre = _genre.map(i => transformGenre(i)).join(', ')

    return genre
  }

  const cn = classNames([classes.item, { [classes.active]: isActive }])
  return (
    <div className={cn}>
      <div className={classes.labels}>
        {[1, 2].includes(item.specialCategory) && (
          <CatalogItemLabel
            isPremiereOrLeader={item.specialCategory}
            type={item.type}
          />
        )}
        <CatalogItemLabel type={item.type} />
      </div>

      <div className={classes.img_wrapper}>
        <Image src={item?.imageSquare?.image?.href} />
      </div>
      <div className={classes.item_info}>
        <div className={classes.info}>
          <span className={classes.item_info_title}>{item.name}</span>
          <small className={classes.item_info_genre}>{renderGenre()}</small>
        </div>
        <i className={`${classes.arrow} icon-arrow-right`}></i>
      </div>
    </div>
  )
}
